import React, { useState } from "react";
import "./CreateClassSidebar.css";
import UploadClassVideos from "../UploadClassVideos/UploadClassVideos";
import ClassDetails from "../ClassDetails/ClassDetails";

function CreateClassSidebar({ classId, isEditing, classData, classVideos, onNewClassId, teacherId }) {
  const [activeTab, setActiveTab] = useState("details"); // Default to "details" tab
  const [newClassId, setNewClassId] = useState(classId); // Initialize with classId

  const handleSetActiveTab = (tab, newClassId = null) => {
    setActiveTab(tab);
    if (newClassId) {
      setNewClassId(newClassId);
      onNewClassId(newClassId)
    }
  };

  return (
    <div className="create-class-sidebar-container">
      {/* Sidebar Navigation */}
      <div className="create-class-sidebar">
        <span className="create-sidebar-title">
          {isEditing ? "Edit Class" : "Create Class"}
        </span>
        <div
          className={`sidebar-item ${activeTab === "details" ? "active" : ""}`}
          onClick={() => handleSetActiveTab("details")}
        >
          Class Details
        </div>
        <div
          className={`sidebar-item ${activeTab === "videos" ? "active" : ""}`}
          onClick={() => handleSetActiveTab("videos")}
        >
          Upload Class Videos
        </div>
      </div>

      {/* Content Display */}
      <div className="content">
        {activeTab === "details" ? (
          <ClassDetails
            teacherId={teacherId}
            classId={newClassId}
            isEditing={isEditing} 
            classData={classData}
            setActiveTab={handleSetActiveTab}
          />
        ) : (
          <UploadClassVideos
            classId={newClassId}
            classData={classData}
            classVideos={classVideos}
          />
        )}
      </div>
    </div>
  );
}

export default CreateClassSidebar;